import React from 'react';
import { useTranslation } from 'react-i18next';
import AIAvatar from '../AIAvatar';

/**
 * "AI is thinking" indicator — branded avatar + three-dot wave bubble.
 * Renders as a full message row so callers can drop it directly into the
 * chat scroll area without wrapping with a separate icon.
 *
 * Motion:
 *   - Dots use a soft wave (opacity + 3px lift) instead of a hard bounce.
 *   - The avatar carries a gentle emerald halo pulse while streaming.
 *   - All animation is disabled under prefers-reduced-motion.
 */
export default function TypingIndicator({ testId = 'ai-chat-typing-indicator' }) {
  const { t } = useTranslation();
  const thinkingLabel = t('aiAdvisor.thinking');
  return (
    <div data-testid={testId} className="rp-advisor-msg-in flex gap-3 items-end">
      <span className="relative inline-flex" style={{ width: 32, height: 32 }} aria-hidden="true">
        <span className="rp-advisor-typing-halo absolute inset-0 rounded-full bg-emerald-400/40" />
        <AIAvatar size={32} label={t('aiAdvisor.brand')} className="relative" />
      </span>
      <div
        className="flex items-center gap-1.5 px-4 py-3 rounded-2xl rounded-tl-sm bg-slate-100 dark:bg-slate-800/70 border border-transparent dark:border-slate-700/40 w-fit"
        aria-label={thinkingLabel}
        role="status"
      >
        <span className="rp-advisor-typing-dot w-2 h-2 rounded-full bg-[#12355B]/70 dark:bg-[#45C04A]/80" style={{ animationDelay: '0ms' }} />
        <span className="rp-advisor-typing-dot w-2 h-2 rounded-full bg-[#12355B]/70 dark:bg-[#45C04A]/80" style={{ animationDelay: '180ms' }} />
        <span className="rp-advisor-typing-dot w-2 h-2 rounded-full bg-[#12355B]/70 dark:bg-[#45C04A]/80" style={{ animationDelay: '360ms' }} />
      </div>
    </div>
  );
}
